/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-13 16:21:11
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-05-14 10:47:05
 * @FilePath: \crm-product\found\views\tpm\views\activity\material_usage_close\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-13 15:39:33
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-05-14 10:45:28
 * @FilePath: \crm-product\found\views\tpm\views\activity\material_usage_close\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Page from '@/found/components/table_page';
import Form from '../form/index';
import { ProcessLog } from '../../../../../../modules';

export default {
  name: 'material_usage_close',
  extends: Page,
  data() {
    return {
      params: {},
    };
  },
  components: {
    Form,
    ProcessLog,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { approveStatus, processNo } = row;
      if (approveStatus && code === 'edit' && (approveStatus === '1' || approveStatus === '2')) {
        return false;
      }
      if (code === 'process_log' && !processNo) {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      const { code } = val;
      if (code === 'edit' || code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      } else if (code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row: { processNo: row.processNo },
        };

        this.modalConfig.title = '流程日志';
        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
  },
};
